module.exports = __webpack_public_path__ + "img/providerES.0157aedf.png";